module.exports = __webpack_public_path__ + "media/images/icons/ic-propose-event-d55691865d131ffc71a7f35824fab5f7.svg";